import Axios from "@/plugins/Axios";

export class PlanosBimestraisInfantil {
  async planoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais-infantil/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async salvarPlanosBimestrais(plano) {
    const response = await Axios().post(`planos-bimestrais-infantil/salvar-planos-bimestrais`, {
      plano,
    });
    return response.data;
  }

  async pegarPlanos(gestaoDeAulaI) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/pegar-planos-infantil/${gestaoDeAulaI}`
    );
    return response.data;
  }

  async salvarPlanos(planos, gestaoDeAulaId) {
    const response = await Axios().post(
      `planos-bimestrais-infantil/salvar-planos/${gestaoDeAulaId}`,
      {
        planos,
      }
    );
    return response.data;
  }

  async planoBimestralPDF(gestaoDeAulaId, bimestre, file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await Axios().post(
        `planos-bimestrais-infantil/uploadPdf/${gestaoDeAulaId}/${bimestre}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const resultData = response.data ?? response;
      if (resultData) {
        return resultData;
      }
      return null;
    } catch (error) {
      // console.error("Erro ao enviar o arquivo:", error);
      // throw error;
    }
  }

  async planoBimestralDownload(gestaoDeAulaId, bimestre) {
    const response = await Axios()
      .get(`planos-bimestrais-infantil/downloadPdf/${gestaoDeAulaId}/${bimestre}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async planoAnexado(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais-infantil/${planoId}/relatorio-anexado`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async removerPlanoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().delete(
      `planos-bimestrais-infantil/remover-plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }
}

export default new PlanosBimestraisInfantil();
